import { h, Component } from 'preact';
import style from './index.less';
import {
	TimeSlots, 
	CollectInformation, 
	Confirmation, 
	Receipt, 
	Payment
} from 'components/templates'
import {
	Login,
	Filters,
	PasswordReset,
	ResetPasswordPrompt,
	ProfileSelect
} from 'components/partials'
import {
	Steps,
	LoginOrSignup
} from 'components/groups'
import {Page, Footer} from 'components/elements'
import { Provider, connect } from 'react-redux';
import store from 'reducers'
import * as actions from 'actions';
const LocaleActions = actions.LocaleActions
window.minnowActions = actions;
@connect((state)=>(
	{
		...state,
		access: ((state.session || {}).organizations || []).find((_)=> _.id == state.organization.id)
	}
))
class Widget extends Component {
	constructor(){
		super();
		this.state = {
			size: 'sm'
		};
		const _onresize = document.onresize 
		window.addEventListener('resize', (e)=>{
			this.handleWidth()
		})
	}
	componentDidMount(){
		this.handleWidth()
	}

	handleWidth(){
		let size;
		if((this.mainElement || {}).clientWidth < 768){
			size = 'sm'
		}else if((this.mainElement || {}).clientWidth < 992){
			size = 'md'
		}else{
			size = 'lg'
		}

		this.setState({
			size
		})
	}
	setLocale(locale, e) {
		e.preventDefault()
		LocaleActions.setLocale(locale)
	}
	render() {
		const classes = [style.widgetContainer, this.state.size]
		this.props.roboto != false && classes.push('roboto')

		return (
			<div class={classes.join(' ')} ref={(_)=> this.mainElement = _}>
				{this.props.roboto != false && (
					<link href="https://fonts.googleapis.com/css?family=Roboto" rel="stylesheet" />
					)}
				<a href="#" onClick={this.setLocale.bind(null, "en")}>English</a> &nbsp;
				<a href="#" onClick={this.setLocale.bind(null, "esp")}>Español</a> &nbsp;
				<a href="#" onClick={this.setLocale.bind(null, "fr")}>Français</a>
				<br />
				{!this.props.config.hideSteps && (
					<Steps />
				)}
				<div class={style.containerPage}>
					<Page componentPage={'loginOrSignup'} component={LoginOrSignup} />
					<Page componentPage={'profileSelect'} component={ProfileSelect} />
					<Page componentPage={'login'} component={Login} />
					<Page componentPage={'passwordReset'} component={PasswordReset} />
					<Page componentPage={'resetPasswordPrompt'} component={ResetPasswordPrompt} />
					<Page componentPage={'filters'} component={Filters} />
					<Page componentPage={'timeSlots'} component={TimeSlots} />
					<Page componentPage={'collectInformation'} component={CollectInformation} />
					<Page componentPage={'confirmation'} component={Confirmation} />
					<Page componentPage={'receipt'} component={Receipt} />
					<Page componentPage={'payment'} component={Payment} />
				</div>
				<br />
				
				<div class={style.containerFooter}>
					<a href="https://www.nextinline.io/">
						Powered by Next In Line
					</a>
				</div>
			</div>
		);
	}
}

export default ()=>(
	<Provider store={store}>
		<Widget />
	</Provider>
)


// WEBPACK FOOTER //
// ./components/widget/index.js